var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":"Invoices","active":_vm.isActive}},[_c('p',[_vm._v("Invoice Tab")])])}
var staticRenderFns = []

export { render, staticRenderFns }